export default __webpack_public_path__ + "static/media/2504273.cae193bc.jpg";